/* =========================================================================
   BLACK ANTECIPADA — UM CARTÃO SÓ NA GAVETA (20/10/2026)

   A roleta tinha o cartão "adicione mais R$ X e ganhe o presente" e a 2ª peça
   pediria outro ("adicione a 2ª peça com 25% OFF"). Dois cartões no mesmo canto
   não dá; aqui os dois viraram UM cartão com estados, na ordem do que vale mais
   para a cliente naquele momento:

     1. peça sem par (1, 3, 5...)  -> "Adicione a 2ª peça e ganhe 25% OFF nela"
                                      (+ linha do presente, se ela girou e ainda
                                       está abaixo de R$ 399)
     2. par fechado, cupom fora    -> "Aplique o BLACK25" (botão aplica na hora)
     3. girou, abaixo de R$ 399    -> "Faltam R$ X para o presente surpresa"
     4. nada disso                 -> nenhum cartão

   Lê o estado publicado pela gaveta (snippets/tp-black-carrinho.liquid,
   <script data-tp-bk>), refeito a cada mudança do carrinho. Mesmo desenho dos
   cartões das outras campanhas (tp-ddc / tp-pfaltam). "Não, obrigada" cala o
   estado atual por 30 min (localStorage tp-bkc-silencio).

   A OFERTA MANDA (regra do Guilherme): ao abrir, avisa pelo evento
   tp-oferta-cartao e os cartões da roleta (tp-presente.js) saem de cena.
   ========================================================================= */
(function () {
  if (window.__tpBlack) return;
  window.__tpBlack = true;

  var raiz = null, timer = null, visto = null, vistoTxt = null;
  function brl(c) { return 'R$ ' + (c / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function avisar(aberto) { try { document.dispatchEvent(new CustomEvent('tp-oferta-cartao', { detail: { aberto: !!aberto, quem: 'black' } })); } catch (e) {} }
  function ganhou() { try { return !!localStorage.getItem('tp-roleta-presente'); } catch (e) { return false; } }
  /* PÁGINA DA GIRE E GANHE (coleção e PDPs dela; todos os handles terminam em gire-e-ganhe, 27/10/2026):
     o cartão da Black não abre (lá vale o da Gire e Ganhe, tp-rgg-presente.js) e o relógio da gaveta diz
     "Gire e Ganhe termina em". */
  function paginaGG() { return /gire-e-ganhe/.test(window.location.pathname); }

  function lerSilencio() {
    var m = {};
    try { var b = JSON.parse(localStorage.getItem('tp-bkc-silencio') || '{}'); if (b && typeof b === 'object') m = b; } catch (e) {}
    var agora = Date.now();
    Object.keys(m).forEach(function (k) { if (!(parseInt(m[k], 10) > agora)) delete m[k]; });
    return m;
  }
  function silenciar(passo) {
    if (!passo) return;
    try { var m = lerSilencio(); m[passo] = Date.now() + 30 * 60 * 1000; localStorage.setItem('tp-bkc-silencio', JSON.stringify(m)); } catch (e) {}
  }

  function montar() {
    if (raiz) return raiz;
    var css = document.createElement('style');
    css.textContent = '.tp-bkc{position:fixed;z-index:2147483000;left:50%;bottom:16px;width:min(100% - 24px,380px);transform:translate(-50%,16px);opacity:0;display:flex;align-items:flex-start;gap:12px;padding:14px 16px 14px 14px;border-radius:16px;background:#222F28;color:#F1F0EB;box-shadow:0 10px 30px rgba(34,47,40,.28);font-family:var(--tp-body-font,"Host Grotesk",ui-sans-serif,system-ui,sans-serif);transition:opacity .22s ease,transform .22s ease}'
      + '.tp-bkc[hidden]{display:none}.tp-bkc.is-aberto{opacity:1;transform:translate(-50%,0)}'
      + '@media (min-width:750px){.tp-bkc{left:auto;right:20px;bottom:20px;transform:translateY(16px)}.tp-bkc.is-aberto{transform:translateY(0)}}'
      + '.tp-bkc__icone{flex:0 0 auto;width:38px;height:38px;border-radius:12px;background:rgba(255,170,153,.18);color:#FFAA99;display:inline-flex;align-items:center;justify-content:center;font-weight:800;font-size:15px;letter-spacing:-.02em}.tp-bkc__icone svg{width:20px;height:20px}'
      + '.tp-bkc__corpo{flex:1 1 auto;min-width:0}.tp-bkc__eyebrow{margin:0 0 2px;font-size:1.05rem;letter-spacing:.1em;text-transform:uppercase;color:#FFAA99;font-weight:600}'
      + '.tp-bkc__titulo{margin:0 0 4px;font-size:1.45rem;line-height:1.3;font-weight:600}.tp-bkc__titulo b{color:#FFAA99;font-weight:700}'
      + '.tp-bkc__texto{margin:0 0 10px;font-size:1.2rem;line-height:1.4;color:rgba(241,240,235,.78)}.tp-bkc__texto b{color:#F1F0EB;font-weight:700}'
      + '.tp-bkc__acoes{display:flex;align-items:center;gap:14px;flex-wrap:wrap}'
      + '.tp-bkc__sim{display:inline-flex;align-items:center;padding:9px 14px;border-radius:999px;border:0;background:#FFAA99;color:#222F28;font:inherit;font-size:1.25rem;font-weight:700;text-decoration:none;cursor:pointer}'
      + '.tp-bkc__sim[disabled]{opacity:.7;cursor:default}'
      + '.tp-bkc__nao{border:0;background:transparent;padding:6px 2px;color:rgba(241,240,235,.75);font:inherit;font-size:1.2rem;text-decoration:underline;text-underline-offset:3px;cursor:pointer}';
    document.head.appendChild(css);
    var el = document.createElement('div');
    el.className = 'tp-bkc';
    el.setAttribute('role', 'status');
    el.hidden = true;
    el.innerHTML = '<span class="tp-bkc__icone" aria-hidden="true" data-bkc-icone>2ª</span>'
      + '<div class="tp-bkc__corpo"><p class="tp-bkc__eyebrow">Black Antecipada</p><p class="tp-bkc__titulo" data-bkc-titulo></p><p class="tp-bkc__texto" data-bkc-texto></p>'
      + '<div class="tp-bkc__acoes"><button type="button" class="tp-bkc__sim" data-bkc-sim></button><button type="button" class="tp-bkc__nao" data-bkc-nao>Não, obrigada</button></div></div>';
    document.body.appendChild(el);
    el.querySelector('[data-bkc-nao]').addEventListener('click', function () { silenciar(raiz.__passo); fechar(); });
    el.querySelector('[data-bkc-sim]').addEventListener('click', function () {
      var acao = raiz.__acao;
      if (acao && acao.tipo === 'link') { silenciar(raiz.__passo); window.location.href = acao.url; return; }
      if (acao && acao.tipo === 'cupom') { aplicarCupom(acao.cupom); return; }
      fechar();
    });
    var cd = document.querySelector('cart-drawer');
    if (cd && window.MutationObserver) new MutationObserver(function () { setTimeout(posicionar, 350); }).observe(cd, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', posicionar);
    raiz = el;
    return el;
  }
  function posicionar() {
    if (!raiz) return;
    if (window.innerWidth < 750) { raiz.style.right = ''; return; }
    var cd = document.querySelector('cart-drawer.active, cart-drawer[open]');
    var painel = cd && (cd.querySelector('[class*="drawer__inner"]') || cd.firstElementChild);
    var r = painel && painel.getBoundingClientRect();
    raiz.style.right = (r && r.width > 0 && r.width < window.innerWidth - 100) ? (window.innerWidth - r.left + 16) + 'px' : '';
  }
  function fechar() {
    if (!raiz || raiz.hidden) return;
    var estavaAberto = raiz.classList.contains('is-aberto');
    raiz.classList.remove('is-aberto');
    var el = raiz;
    setTimeout(function () { if (!el.classList.contains('is-aberto')) el.hidden = true; }, 240);
    if (estavaAberto) avisar(false);
  }
  function bloqueado() {
    var h = document.documentElement.classList;
    return h.contains('tp-roleta-open') || h.contains('tp-pg-open') || h.contains('tp-pt-open') || h.contains('tp-pe-open');
  }

  /* Aplica o cupom e redesenha a gaveta: /discount/CODIGO prende o código ao carrinho;
     /cart/update.js com `sections` devolve a gaveta já com o desconto, que o
     cart-drawer do tema troca por renderContents (mesmo caminho do "adicionar"). */
  var segurando = false; /* cartão parado mostrando o check (21/10/2026) */
  function aplicarCupom(cupom) {
    var sim = raiz && raiz.querySelector('[data-bkc-sim]');
    var drawer = document.querySelector('cart-drawer');
    var secoes = (drawer && typeof drawer.getSectionsToRender === 'function') ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-drawer', 'cart-icon-bubble'];
    /* Animação do "aplicar" (21/10/2026): assets/tp-cupom-ok.js faz pontinhos → check desenhado → anel.
       O pedido continua o mesmo (/discount + /cart/update.js com sections + renderContents). A gaveta
       redesenhada já mostra "Cupom aplicado!", então aqui não sobe o aviso do topo. O cartão fica
       1,1 s parado com o check e só então fecha (`segurando` trava o decidir nesse meio-tempo). */
    if (window.tpCupomOk && sim) {
      segurando = true;
      var pedido = function () {
        /* redirect manual: seguir o 302 baixava a home inteira e segurava o check por ~0,8 s */
        return fetch('/discount/' + encodeURIComponent(cupom), { credentials: 'same-origin', redirect: 'manual' })
          .then(function () {
            return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: cupom, sections: secoes.join(','), sections_url: window.location.pathname }) });
          })
          .then(function (r) { return r.json(); })
          .then(function (estado) {
            try { if (drawer && typeof drawer.renderContents === 'function' && estado && estado.sections) drawer.renderContents(estado); } catch (e) {}
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tp-black', cartData: estado }); } catch (e) {} }
            return estado;
          });
      };
      window.tpCupomOk.aplicar(sim, cupom, { pedido: pedido, textoOk: 'Aplicado', toast: false, textoErro: 'Aplicar ' + cupom }).then(function (ok) {
        if (!ok) { segurando = false; return; }
        setTimeout(function () { segurando = false; fechar(); setTimeout(decidir, 300); }, 1100);
      });
      return;
    }
    if (sim) { sim.disabled = true; sim.textContent = 'Aplicando...'; }
    fetch('/discount/' + encodeURIComponent(cupom), { credentials: 'same-origin' })
      .then(function () {
        return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: cupom, sections: secoes.join(','), sections_url: window.location.pathname }) });
      })
      .then(function (r) { return r.json(); })
      .then(function (estado) {
        try { if (drawer && typeof drawer.renderContents === 'function' && estado && estado.sections) drawer.renderContents(estado); } catch (e) {}
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tp-black', cartData: estado }); } catch (e) {} }
        try { sessionStorage.setItem('tp-cupom-aplicado', cupom); } catch (e) {}
        fechar();
      })
      .catch(function () { if (sim) { sim.disabled = false; sim.textContent = 'Aplicar ' + cupom; } });
  }

  function decidir() {
    if (segurando) return;
    var el = document.querySelector('[data-tp-bk]');
    if (!el) { fechar(); return; }
    var d; try { d = JSON.parse(el.textContent); } catch (e) { return; }
    if (!d.ativa) { fechar(); return; }
    if (paginaGG()) { fechar(); return; }
    if (d.fim && Date.now() / 1000 > d.fim) { fechar(); return; }
    /* Grupo VIP (22/10/2026, snippets/tp-black-vip): o cartão fala e aplica o BLACK30. Se ela está com o
       BLACK25, conta como "sem cupom" e o cartão oferece trocar pelo BLACK30. */
    var vip = window.tpBlackVip;
    if (vip) {
      d.cupom = vip.codigo; d.pct = vip.pct;
      if (d.cupomAplicado && d.cupomAtual && d.cupomAtual !== vip.codigo) d.cupomAplicado = false;
    }

    var g = ganhou();
    var faltaPresente = g && d.totalPagas > 0 && d.totalPagas < d.presenteMinimo;
    var estado = null, passo = '', titulo = '', texto = '', icone = '+1', acao = null;
    var economia = Math.round(d.maxPreco * d.pct / 100);

    /* 22/10/2026 (Guilherme): o cartão do 25% OFF / BLACK25 SAIU da gaveta. Os estados "mais uma peça" e
       "aplique o cupom" só continuam para o Grupo VIP (tpBlackVip, BLACK30); para todo mundo fica só o do
       presente. A barra de recompensas e a faixa da coleção seguem falando do cupom. */
    if (vip && d.qtd > 0 && d.qtd % 2 === 1) {
      estado = 'segunda'; passo = 'black:seg:' + d.qtd;
      titulo = 'Adicione <b>mais uma peça</b> e ganhe <b>' + d.pct + '% OFF</b> na de menor valor';
      texto = (economia > 0 ? 'Até <b>' + brl(economia) + ' OFF</b> com o cupom <b>' + d.cupom + '</b>.' : 'Com o cupom <b>' + d.cupom + '</b> no carrinho.');
      if (faltaPresente) texto += ' Acima de R$ 399 o seu <b>presente surpresa' + (d.presenteValor > 0 ? ' de ' + brl(d.presenteValor) : '') + '</b> vai junto.';
      acao = { tipo: 'link', url: d.url || '/collections/black-antecipada', rotulo: 'Escolher outra peça' };
    } else if (vip && d.qtd >= 2 && !d.cupomAplicado) {
      estado = 'cupom'; passo = 'black:cupom:' + d.qtd;
      /* Par fechado: o desconto cai na peça MAIS BARATA do carrinho, então o valor é exato
         (25% dela), não "até". */
      var exato = Math.round((d.minPreco || d.maxPreco) * d.pct / 100);
      titulo = 'Aplique o <b>' + d.cupom + '</b> e ganhe <b>' + d.pct + '% OFF</b>';
      texto = 'Na peça de menor valor' + (exato > 0 ? ': <b>' + brl(exato) + ' OFF</b>' : '') + '.';
      icone = '%';
      acao = { tipo: 'cupom', cupom: d.cupom, rotulo: 'Aplicar ' + d.cupom };
    } else if (faltaPresente) {
      estado = 'presente'; passo = 'black:pres';
      titulo = 'Adicione mais <b>' + brl(d.presenteMinimo - d.totalPagas) + '</b> e ganhe o presente surpresa' + (d.presenteValor > 0 ? ' de <b>' + brl(d.presenteValor) + '</b>' : '');
      texto = 'Ele entra sozinho no carrinho, por nossa conta.';
      icone = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M2.9 9.4h14.2v7.2a1 1 0 0 1-1 1H3.9a1 1 0 0 1-1-1V9.4z"/><path d="M2.1 6.6h15.8v2.8H2.1z"/><path d="M10 6.6v11"/><path d="M10 6.6S8.9 2.5 6.8 2.5a1.9 1.9 0 0 0 0 4.1H10z"/><path d="M10 6.6s1.1-4.1 3.2-4.1a1.9 1.9 0 0 1 0 4.1H10z"/></svg>';
      acao = { tipo: 'link', url: d.url || '/collections/black-antecipada', rotulo: 'Ver as peças' };
    }
    if (!estado) { fechar(); return; }
    if (lerSilencio()[passo]) { fechar(); return; }
    if (bloqueado()) return;

    var box = montar();
    box.__passo = passo;
    box.__acao = acao;
    box.querySelector('[data-bkc-icone]').innerHTML = icone;
    box.querySelector('[data-bkc-titulo]').innerHTML = titulo;
    box.querySelector('[data-bkc-texto]').innerHTML = texto;
    var sim = box.querySelector('[data-bkc-sim]');
    sim.disabled = false;
    sim.classList.remove('is-aplicando', 'is-aplicado', 'is-quieto');
    sim.textContent = acao.rotulo;
    var jaAberto = box.classList.contains('is-aberto');
    if (box.hidden) { box.hidden = false; void box.offsetWidth; }
    box.classList.add('is-aberto');
    posicionar();
    /* A gaveta ainda pode estar deslizando quando o cartão nasce: reposiciona depois. */
    setTimeout(posicionar, 450); setTimeout(posicionar, 1000);
    if (!jaAberto) avisar(true);
  }

  /* RELÓGIO DA BLACK NA BARRA DE RECOMPENSAS (21/10/2026, Guilherme: "um countdown ali na área superior,
     ocupando pouco espaço"). Uma linha dentro da caixa da barra: "Black Antecipada termina em 11d 08h 24min"
     (no último dia, h/min/s). O relógio diário hh:mm:ss do tema (.tp-cdc) fica escondido na dev pelo
     tp-black-tema.css — dois relógios na mesma caixa confundem. O `fim` vem do JSON data-tp-bk (epoch, s).
     DICA "GIRE A ROLETA": o marco do presente na barra só se cumpre para quem girou; quem ainda não girou
     vê, ao lado da manchete da barra, um botão "gire a roleta" que fecha a gaveta e abre a roleta. */
  var relogioTimer = 0;
  function doisDig(n) { return (n < 10 ? '0' : '') + n; }
  function relogio() {
    var el = document.querySelector('[data-tp-bk]');
    var caixa = document.querySelector('#CartDrawer .tp-rewards');
    if (!el || !caixa) return;
    /* GIRE E GANHE NO CARRINHO (27/10/2026): a barra vem com data-rgg (tp-cart-rewards-bar) e não leva o
       relógio da Black -- o BLACK25 não vale nas peças dela e o presente da Black não entra. Só remove se existir
       (mexer na gaveta dispara o MutationObserver que chama relogio() de novo). */
    var gg = paginaGG();
    if (!gg && caixa.hasAttribute('data-rgg')) { var velha = caixa.querySelector('.tp-bkh'); if (velha) velha.remove(); return; }
    var fim = 0;
    try { fim = (JSON.parse(el.textContent) || {}).fim * 1000; } catch (e) { fim = 0; }
    if (!fim) return;
    var linha = caixa.querySelector('.tp-bkh');
    if (!linha) {
      linha = document.createElement('p');
      linha.className = 'tp-bkh';
      linha.innerHTML = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="10" cy="10" r="7.5"/><path d="M10 5.5V10l3 2"/></svg><span>' + (gg ? 'Gire e Ganhe' : 'Black Antecipada') + ' termina em <b data-bkh></b></span>';
      caixa.appendChild(linha);
    }
    var b = linha.querySelector('[data-bkh]');
    var resta = Math.max(0, Math.floor((fim - Date.now()) / 1000));
    if (resta <= 0) { if (!linha.hidden) linha.hidden = true; return; }
    if (linha.hidden) linha.hidden = false;
    var d = Math.floor(resta / 86400), h = Math.floor((resta % 86400) / 3600), m = Math.floor((resta % 3600) / 60), s = resta % 60;
    var novo = d > 0 ? (d + 'd ' + doisDig(h) + 'h ' + doisDig(m) + 'min') : (doisDig(h) + 'h ' + doisDig(m) + 'min ' + doisDig(s) + 's');
    /* SÓ ESCREVE SE MUDOU (21/10/2026, travou o preview da dev por uns minutos): escrever o texto é uma
       mutação da gaveta, e o MutationObserver da gaveta chama relogio() de novo → loop infinito síncrono. */
    if (b.textContent !== novo) b.textContent = novo;
    clearTimeout(relogioTimer);
    relogioTimer = setTimeout(relogio, d > 0 ? 30000 : 1000);
  }
  function dicaRoleta() {
    var titulo = document.querySelector('#CartDrawer .tp-rewards .tp-rewards__titulo');
    if (!titulo) return;
    var atual = titulo.querySelector('.tp-bkh-roleta');
    var precisa = !paginaGG() && !ganhou() && /presente/i.test(titulo.textContent) && !!(window.tpRoletaV2 && window.tpRoletaV2.abrir);
    if (!precisa) {
      /* Girou (ou não há o que pedir): tira a dica e devolve a frase original do Liquid, se ela foi reescrita. */
      if (atual) atual.remove();
      if (titulo.getAttribute('data-bkh-reescrito') && titulo.__bkhOriginal != null) { titulo.innerHTML = titulo.__bkhOriginal; titulo.removeAttribute('data-bkh-reescrito'); }
      return;
    }
    if (atual) return;
    /* ACIMA DO MÍNIMO SEM GIRO (22/10/2026, Guilherme): "Você ganhou PRESENTE SURPRESA! gire a roleta" era
       contraditório -- o "você ganhou" ali vinha só do valor do carrinho. A frase vira
       "Seu PRESENTE SURPRESA está liberado: gire a roleta". Abaixo do mínimo segue "Faltam R$ X para..." + dica. */
    var caixa = titulo.closest('.tp-rewards');
    if (caixa && caixa.classList.contains('tp-rewards--pronto')) {
      if (titulo.__bkhOriginal == null) titulo.__bkhOriginal = titulo.innerHTML;
      titulo.innerHTML = 'Seu <strong class="tp-rewards__premio">Presente surpresa</strong> está liberado:';
      titulo.setAttribute('data-bkh-reescrito', '1');
    }
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'tp-bkh-roleta'; btn.textContent = 'gire a roleta';
    btn.addEventListener('click', function () {
      var cd = document.querySelector('cart-drawer');
      try { if (cd && typeof cd.close === 'function') cd.close(); } catch (e) {}
      setTimeout(function () { try { window.tpRoletaV2.abrir(); } catch (e) {} }, 350);
    });
    titulo.appendChild(document.createTextNode(' '));
    titulo.appendChild(btn);
  }
  function barra() { relogio(); dicaRoleta(); }
  function mudou() {
    var el = document.querySelector('[data-tp-bk]');
    if (!el) return visto !== null ? ((visto = null), true) : false;
    var txt = el.textContent;
    if (el === visto && txt === vistoTxt) return false;
    visto = el; vistoTxt = txt;
    return true;
  }
  function agendar() { clearTimeout(timer); timer = setTimeout(decidir, 120); }
  function iniciar() {
    mudou();
    decidir();
    barra();
    var gaveta = document.getElementById('CartDrawer');
    /* barra() nunca roda DENTRO do observador (seria síncrono e qualquer escrita re-dispararia o observador):
       vai para um timeout curto, uma vez só por rajada de mutações. */
    var barraTimer = 0;
    if (gaveta && window.MutationObserver) new MutationObserver(function () { if (mudou()) agendar(); clearTimeout(barraTimer); barraTimer = setTimeout(barra, 60); }).observe(gaveta, { childList: true, subtree: true });
    document.addEventListener('tp:roleta-presente', dicaRoleta);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { try { subscribe(PUB_SUB_EVENTS.cartUpdate, agendar); } catch (e) {} }
    document.addEventListener('tp:roleta-presente', agendar);
    if (window.MutationObserver) {
      var estava = bloqueado();
      new MutationObserver(function () { var agora = bloqueado(); if (agora && !estava) fechar(); if (estava && !agora) setTimeout(decidir, 500); estava = agora; }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
